var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "page-wrapper"
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('breadcrumb', {
    attrs: {
      "items": _vm.breadcrumbItems
    }
  }), _c('div', {
    staticClass: "row justify-content-md-center"
  }, [_c('div', {
    staticClass: "col-xxl-6 col-xl-6 col-lg-8 col-md-8"
  }, [_c('div', {
    staticClass: "repAdmin-card"
  }, [_c('div', {
    staticClass: "repAdmin-head text-center"
  }, [_c('div', {
    staticClass: "repAdmin-head-content"
  }, [_c('h1', [_vm._v("Rep Administrators")]), _c('div', {
    staticClass: "admin-list-add"
  }, [_vm.addBtn && _vm.isEnrollPrime ? _c('custom-button', {
    attrs: {
      "iconClass": "fas fa-plus ",
      "className": "repAdmin-btn  ",
      "title": "Add Rep"
    },
    on: {
      "onClicked": function onClicked($event) {
        return _vm.$bvModal.show('addRep');
      }
    }
  }) : _vm._e(), _vm.addBtn && !_vm.isEnrollPrime ? _c('custom-button', {
    attrs: {
      "iconClass": "fas fa-plus ",
      "className": "repAdmin-btn  ",
      "title": "Add Nuera Rep"
    },
    on: {
      "onClicked": function onClicked($event) {
        return _vm.$bvModal.show('addRepNuera');
      }
    }
  }) : _vm._e()], 1)]), _c('p', [_vm._v(" Rep Admins are additional accounts that you can add, that will have access to your dashboard. ")])]), _c('div', {
    staticClass: "repAdmin-body"
  }, [_c('h3', [_vm._v("Users")]), _c('rep-admin-list-content', {
    attrs: {
      "reps": _vm.activeReps,
      "type": "all"
    },
    on: {
      "onSuccess": _vm.getAll,
      "emailSelected": _vm.handleEmailSelection
    }
  }), _c('hr'), _c('h3', [_vm._v("Pending Users")]), _c('rep-admin-list-content', {
    attrs: {
      "reps": _vm.pendingReps,
      "type": "pending"
    },
    on: {
      "onSuccess": _vm.getAll
    }
  })], 1), _vm.isEnrollPrime ? _c('rep-admin-add', {
    on: {
      "onSuccess": _vm.getAll
    }
  }) : _vm._e(), !_vm.isEnrollPrime ? _c('rep-admin-add-nuera', {
    on: {
      "onSuccess": _vm.getAll,
      "onCloseModal": function onCloseModal($event) {
        return _vm.$bvModal.hide('addRepNuera');
      }
    }
  }) : _vm._e(), _c('enable-email-modal', {
    attrs: {
      "email": _vm.selectedEmail
    },
    on: {
      "onSubmit": _vm.handleSubmit
    }
  })], 1)])])], 1)]);
}
var staticRenderFns = []

export { render, staticRenderFns }